import $ from 'jquery';

$(function () {
  const $slider = $('.countries-slider');
  if (!$slider.length) return;

  // Prevent double initialization if track already created
  if ($slider.find('.countries-marquee-track').length) return;

  const $items = $slider.children('.country-card-item');
  if (!$items.length) return;

  // Create marquee track wrapper
  const $track = $('<div class="countries-marquee-track"></div>');

  // Append original items
  $track.append($items);

  // Clone original items to create seamless infinite loop sequence
  const $clonedItems = $items.clone(true).addClass('country-card-item-clone');
  $track.append($clonedItems);

  // Mount track into slider container
  $slider.empty().append($track);
});

// Participating Countries Tab Switching
$(function () {
  $(document).on('click', '.participating-tab-btn', function (e) {
    e.preventDefault();
    const $btn = $(this);
    const targetTab = $btn.data('tab');
    if (!targetTab) return;

    // Update active tab button
    $btn.siblings('.participating-tab-btn').removeClass('active').attr('aria-selected', 'false');
    $btn.addClass('active').attr('aria-selected', 'true');

    // Update active tab pane
    const $panes = $('.participating-tab-pane');
    $panes.removeClass('active');
    $('#tab-' + targetTab).addClass('active');
  });
});


